import $ from 'jquery'
// import '../../styles/theme.css.liquid';
import '../../styles/checkout.scss'
import Cookies from 'js-cookie'

document.addEventListener(`DOMContentLoaded`, () => {
    const note = document.querySelector(`[data-rental-note]`)
    const completeOrder = document.querySelector(`[data-trekkie-id="complete_order_button"]`)
    const privacy = document.querySelector(`[data-privacy-text]`)

    if(Cookies.get(`_rent_products`) && note) {
        const orderSummary = document.querySelector(`.order-summary__section--product-list`)
        const noteText = document.createElement(`div`)
        noteText.innerHTML = note.innerHTML
        noteText.classList.add(`rental-note`)

        if (privacy) {
            const privacyText = document.createElement(`div`)
            privacyText.innerHTML = privacy.innerHTML
            privacyText.classList.add(`privacy-text`)

            setTimeout(()=>{
                orderSummary.after(privacyText)
                privacyText.after(noteText)
            },1000)
        }
        else {
            setTimeout(()=>{
                orderSummary.after(noteText)
            },1000)
        }
    }
    else if (privacy) {
        const orderSummary = document.querySelector(`.order-summary__section--product-list`)
        const privacyText = document.createElement(`div`)
        privacyText.innerHTML = privacy.innerHTML
        privacyText.classList.add(`privacy-text`)
        setTimeout(()=>{
            orderSummary.after(privacyText)
        },1000)
    }

    if(Cookies.get(`_rent_products`) && completeOrder) {
        Cookies.set(`_rent_products`, ``, -1)
    }

  })
